import {initializeApp} from 'firebase/app';
import {deleteToken, getMessaging, getToken, onMessage} from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyB7ztUtAj2ajKxlxL6EDj9QKcfiHfDCLUM",
    authDomain: "ndbw-customer-portal.firebaseapp.com",
    projectId: "ndbw-customer-portal",
    storageBucket: "ndbw-customer-portal.appspot.com",
    messagingSenderId: "810715732641",
    appId: "1:810715732641:web:03df5a144386be600beee0"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);


export const deleteDeviceToken = () => {
    return deleteToken(messaging);
}
export const getUserToken = () => {
    return getToken(messaging, {vapidKey: 'BByNjzlmL_SOwRoBJtJAN41XlQddfp1PcIuOouWTK2RRxZizi7l6ZWXglM_UJj9me97ZkRg3F7rTwAjJeKeIHkY'});

}

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
